import React from 'react';
import { HelperMessage } from '@atlaskit/form';
import UpdateBillingAdminsFields from './update-billing-admins-fields';
import { Permissions } from '@atlassian/cssxp-typescommon';

interface Props {
  recipients: string[];
  setDisableSaveButton?: (status: boolean) => void;
}

export const AddBillingAdminsComponent = ({ recipients, setDisableSaveButton }: Props) => {
  return (
    <div className="create-txa-container">
      <h2>Add a Billing Admin</h2>
      <HelperMessage>
        To ensure access to billing info at all times, we recommend that billing accounts have more than one billing
        admin.
      </HelperMessage>
      <UpdateBillingAdminsFields
        recipients={recipients.length > 0 ? recipients : ['']}
        disableSaveButton={(status: boolean) => {
          setDisableSaveButton && setDisableSaveButton(status);
        }}
        isRequired={true}
        placeholder={'Enter email address'}
        allowToAddBillingAdmin={true} // for checking is user has enough permissions to add billign admin
      />
      <hr className="recipient-border" />
    </div>
  );
};
